//店铺接口
/* eslint-disable */
import axios, { $asyncGet, $asyncPost } from './common';
import { Message } from "element-ui";
import { testR, officialId } from "./common";

//获取所有权限
//http://test-api.hakspay.cn/v3/ePlatform/Service/merchant/permission/list
export const getMerchantPermissList = async function () {
  /* return axios.post("v2/ePlatform/Service/merchant/permission/list",{
    access_token:localStorage.getItem("access_token"),
    token_type:localStorage.getItem("token_type")
  })/
 */
  const cls = await mListClassify();
  const permissList = new Set(await mListPermission());
  if (cls !== false && permissList != false && cls.length > 0) {
    var t2 = [];
    var t4 = [];
    var t6 = [];
    // this.all_permission = res.data.resp_data;
    cls.forEach((item, index, arr) => {
      if (item.parent_classify_id.trim() === "0") {
        t2.push({
          id: item.classify_id.trim(),
          label: item.classify_name,
          view_no: item.view_no ? item.view_no : "",
          parent_classify_id: item.parent_classify_id,
          remark: item.remark,
          childList: []
        });
      }
      if (item.parent_classify_id.trim() !== "0") {
        t4.push({
          id: item.classify_id.trim(),
          label: item.classify_name,
          view_no: item.view_no ? item.view_no : "",
          parent_classify_id: item.parent_classify_id,
          remark: item.remark,
          childList: []
        });
      }
    });
    permissList.forEach((item, index) => {
      t6.push({
        id: item.permission_id.trim(),
        label: item.permission_name,
        view_no: item.view_no ? item.view_no : "",
        classify_id: item.classify_id,
        remark: item.description
      });
    });
    for (let j = 0; j < t4.length; j++) {
      for (let i = 0; i < t6.length; i++) {
        if (t6[i].classify_id === t4[j].id) {
          t4[j].childList.push(t6[i]);
        }
      }
    }
    for (let j = 0; j < t2.length; j++) {
      for (let i = 0; i < t4.length; i++) {
        if (t4[i].parent_classify_id === t2[j].id) {
          t2[j].childList.push(t4[i]);
        }
      }
    }
    return Promise.resolve({ t2, t6 });
  }

};

//
//http://test-api.hakspay.cn/v3/ePlatform/Service/merchant/permission/listAccount
//TODO:

//v3/merchant/permission/account/listAccount
/**
 * 获取所有授权过的用户
 * v3/merchant/permission/account/listAccount
 * @returns  获取所有授权过的用户列表
 */
export const permissionListAccount = function () {
  return new Promise((resolve, reject) => {
    axios
      .post("v3/merchant/permission/account/listAccount", {
        access_token: localStorage.getItem("access_token"),
        token_type: localStorage.getItem("token_type"),
        merchant_id: localStorage.getItem("merchant_id")
      })
      .then(res => {
        /* console.log("获取授权用户接口：",res);
        resolve(res); */
        if (testR(res)) {
          let list = [];
          for (let i = 0; i < res.data.resp_data.length; i++) {
            list.push(res.data.resp_data[i]);
          }
          resolve(list);
        }
      })
      .catch(err => {
        Message.error(err);
      });
  });
};

/**操作员授权
 * v3/merchant/permission/account/set
 * @param {*} account_id
 * @param {*} permission_no
 * @param {string} account_type mobile_no account_id
 * @returns
 */
export const setAccountPermissionASMerchant = function (
  account_id,
  permission_no,
  account_type
) {
  const data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    merchant_id: localStorage.getItem("merchant_id"),
    // [account_type]:account_id,
    account_id,
    account_type,
    permission: permission_no
  };

  return axios.post("v3/merchant/permission/account/set", data).catch(err => {
    Message.error(err);
  });
};

/**删除操作员权限
 * v3/merchant/permission/account/delete
 * @param {*} account_id
 * @param {*} permission_no
 * @returns
 */
export const delAccountPermissionASMerchant = function (
  account_id,
  permission_no
) {
  return axios
    .post("v3/merchant/permission/account/delete", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      merchant_id: localStorage.getItem("merchant_id"),
      account_id,
      permission_no
    })
    .catch(err => {
      Message.error(err);
    });
};

/**查询用户授权
 * v3/merchant/permission/account/query
 * @param {*} account_id
 * @returns
 */
export const queryAccountPermissionASMerchant = function (account_id) {
  return axios
    .post("v3/merchant/permission/account/query", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      merchant_id: localStorage.getItem("merchant_id"),
      account_id
    })
    .catch(err => {
      Message.error(err);
    });
};

/**获取所有用户组
 * v3/merchant/Usergroup/list
 * @returns
 */
export const MusergroupList = function () {
  return new Promise((resolve, reject) => {
    axios
      .post("v3/merchant/Usergroup/list", {
        access_token: localStorage.getItem("access_token"),
        token_type: localStorage.getItem("token_type"),
        merchant_id: localStorage.getItem("merchant_id")
      })
      .then(res => {
        if (testR(res)) {
          resolve(res.data.resp_data);
        }
      })
      .catch(e => {
        Message.error(e);
      });
  });
};

/**新增用户组
 * v3/merchant/Usergroup/generate
 * @param {*} data
 * @returns
 */
export const McreateUserGroup = function (data) {
  return axios
    .post("v3/merchant/Usergroup/generate", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      group_no: data.group_no,
      group_name: data.group_name,
      merchant_id: localStorage.getItem("merchant_id")
    })
    .catch(e => {
      Message.error(e);
    });
};

/**修改用户组
 * v3/merchant/Usergroup/modify
 * @param {*} data
 * @returns
 */
export const MmodifyUserGroup = function (data) {
  return axios
    .post("v3/merchant/Usergroup/modify", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      merchant_id: localStorage.getItem("merchant_id"),
      group_id: data.group_id,
      group_no: data.group_no,
      group_name: data.group_name,
      flag: data.flag
    })
    .catch(e => {
      Message.error(e);
    });
};

/**给用户组授权
 * v3/merchant/usergroupPermission/set
 * @param {*} param0
 * @returns
 */
export const MsetUserGroupPermission = function ({
  group_no,
  group_id,
  permission_no,
  description
}) {
  return axios
    .post("v3/merchant/usergroupPermission/set", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      merchant_id: localStorage.getItem("merchant_id"),
      group_id,
      group_no,
      permission_no,
      description
    })
    .catch(e => {
      Message.error(e);
    });
};

/**删除用户组授权
 * v3/merchant/usergroupPermission/delete
 * @param {*} param0
 * @returns
 */
export const MdeleteUserGroupPermission = function ({
  group_id,
  permission_no,
  group_no
}) {
  return axios
    .post("v3/merchant/usergroupPermission/delete", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      merchant_id: localStorage.getItem("merchant_id"),
      group_id,
      permission_no,
      group_no
    })
    .catch(e => {
      Message.error(e);
    });
};

/**删除用户组
 * v3/merchant/Usergroup/delete
 * @param {*} group_id
 * @returns
 */
export const MdeleteUsrGroup = function (group_id) {
  return axios
    .post("v3/merchant/Usergroup/delete", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      merchant_id: localStorage.getItem("merchant_id"),
      group_id
    })
    .catch(e => {
      Message.error(e);
    });
};

/**获取用户组权限
 * v3/merchant/usergroupPermission/query
 * @param {*} group_id
 * @returns
 */
export const MusergroupQuery = function (group_id) {
  return axios
    .post("v3/merchant/usergroupPermission/query", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      merchant_id: localStorage.getItem("merchant_id"),
      group_id
    })
    .catch(e => {
      Message.error(e);
    });
};

//TODO:
//店铺授权
//http://test-api.hakspay.cn/v3/ePlatform/Service/merchant/permission/merchant/set
export const permissionMerchantSet = async function (mch_no, permission_no) {
  try {
    return await axios.post("v3/merchant/permission/merchant/set", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      approve_mch_no: mch_no,
      merchant_id: localStorage.getItem("merchant_id"),
      mch_no: localStorage.getItem("merchant_id"),
      permission_no
    });
  } catch (e) {
    Message.error(e);
  }
};
//TODO:
//删除店铺权限
//http://test-api.hakspay.cn/v3/ePlatform/Service/merchant/permission/merchant/delete
export const permissionMerchantDelete = async function (mch_no, permission_no) {
  try {
    return await axios.post("v3/merchant/permission/merchant/delete", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      approve_mch_no: mch_no,
      merchant_id: localStorage.getItem("merchant_id"),
      mch_no: localStorage.getItem("merchant_id"),
      permission_no
    });
  } catch (e) {
    Message.error(e);
  }
};
//TODO:
//查询店铺授权
//http://test-api.hakspay.cn/v3/ePlatform/Service/merchant/permission/merchant/query
export const permissionMerchantQuery = async function (mch_no) {
  try {
    return await axios.post("v3/merchant/permission/merchant/query", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      merchant_id: localStorage.getItem("merchant_id"),
      approve_mch_no: mch_no
    });
  } catch (e) {
    Message.error(e);
  }
};
//TODO:
//检索所有授权店铺
//http://test-api.hakspay.cn/v3/ePlatform/Service/merchant/permission/merchant/listmerchant
export const permissionMerchantList = async function () {
  try {
    return new Promise((resolve, reject) => {
      axios
        .post("v3/merchant/permission/merchant/listMerchant", {
          access_token: localStorage.getItem("access_token"),
          token_type: localStorage.getItem("token_type"),
          merchant_id: localStorage.getItem("merchant_id")
        })
        .then(res => {
          if (testR(res)) {
            let list = [];
            for (let i = 0; i < res.data.resp_data.length; i++) {
              list.push(res.data.resp_data[i]);
            }
            resolve(list);
          }
        })
        .catch(err => {
          Message.error(err);
        });
    });
    /* return await axios
      .post("v2/ePlatform/Service/merchant/permission/merchant/delete", {
        access_token: localStorage.getItem("access_token"),
        token_type: localStorage.getItem("token_type"),
        mch_no:localStorage.getItem("merchant_id")
      }); */
  } catch (e) {
    Message.error(e);
  }
};

/**
 * 获取店铺信息
 * v3/merchant/common/query
 */
export const getMerchantInfo = function () {
  const data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    merchant_id: localStorage.getItem("merchant_id")
  };
  return axios.get("v3/merchant/common/query", data).catch(e => {
    Message.error(e);
  });
};

/**修改店铺信息
 * v3/merchant/common/modify
 * @param {*} info
 * @returns
 */
export const modifyMerchantInfo = function (info) {
  const data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    merchant_id: localStorage.getItem("merchant_id"),
    info
  };
  return axios.post("v3/merchant/common/modify", data).catch(e => {
    Message.error(e);
  });
};

/**注册打印模板
 *v3/merchant/print/register
 */
export const printRegister = function (obj, design) {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    merchant_id: localStorage.getItem("merchant_id"),
    ...obj,
    design
  };
  return axios
    .post("v3/merchant/print/register", JSON.stringify(data))
    .catch(e => {
      Message.error(e);
    });
};

/**获取所有打印模板
 *v3/merchant/print/list
 */
export const getprintList = function () {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    merchant_id: localStorage.getItem("merchant_id")
  };
  return axios.post("v3/merchant/print/list", JSON.stringify(data)).catch(e => {
    Message.error(e);
  });
};

/**按模板号搜索模板
 * v3/merchant/print/query
 * @param {string} template_no 模板号
 * @returns json
 */
export const printQuery = function (template_no) {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    merchant_id: localStorage.getItem("merchant_id"),
    template_no
  };
  return axios
    .post("v3/merchant/print/query", JSON.stringify(data))
    .catch(e => {
      Message.error(e);
    });
};

/**
 * v3/merchant/print/modify
 * @param {*} obj
 * @param {*} design
 * @returns
 */
export const printModify = function (obj, design) {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    merchant_id: localStorage.getItem("merchant_id"),
    ...obj,
    design
  };
  console.log(JSON.stringify(data));
  return axios
    .post("v3/merchant/print/modify", JSON.stringify(data))
    .catch(e => {
      Message.error(e);
    });
};

/**
 * 获取所有打印机
 * v3/merchant/offlinestores/message
 *
 */
export const offlinestoresMessage = function () {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    merchant_id: localStorage.getItem("merchant_id"),
    url: "/common/ExService/ListPrinter"
  };
  return axios
    .post("v3/merchant/offlinestores/message", JSON.stringify(data))
    .catch(e => {
      Message.error(e);
    });
};

/**删除模板
 * v3/merchant/print/delete
 */
export const printDelete = function (template_no) {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    merchant_id: localStorage.getItem("merchant_id"),
    template_no
  };
  return axios.post("v3/merchant/print/delete", JSON.stringify(data));
};

/**
 * 获取所有线上类别
 */
export const classifyList = function () {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    merchant_id: localStorage.getItem("merchant_id")
  };
  return new Promise((resolve, reject) => {
    axios.post("v3/merchant/chain/classify/list", JSON.stringify(data))
      .then(res => {
        if (testR(res)) {
          resolve(res.data.resp_data);
        } else {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject(false);
        }
      })
      .catch(e => {
        reject(e);
      });
  });
};

//TODO: 这个appid 是测试版到时候需要改成正式版
/**
 * v3/merchant/common/Attention
 * 获取店铺关注链接
 */
export const getAttention = function () {
  return axios.get(
    `v3/merchant/common/Attention?mch_no=${localStorage.getItem("merchant_id")}&appid=wxf003ddc051b4643b`
  );
};

/**
 * 微信unionid换取openid
 * 
 */
export const wxUnionIdToOpenId = function (union_id) {
  return axios.get(
    `v3/Membership/Account/unionToOpenID?appid=${officialId}&union_id=${union_id}`);
}

/**
  * 店铺所有基本权限
  *
  */
export const mListPermission = function () {
  return $asyncGet(`v3/merchant/permission/listPermission`)
}

/**
 * 店铺获取所有权限分类
 * @returns 
 */
export const mListClassify = function () {
  return $asyncGet(`v3/merchant/permission/listclassify`)
}


/**
 * 店铺新建用角色
 * v3/merchant/UserRole/generate
 * @param {object} roleData 角色信息
 * @param {string[]} permission 权限列表
 */
export const mUserRoleGenerate = function (roleData, permission) {
  console.log("roleData", roleData);
  console.log("permission", permission);
  const roleDatas = {
    role_no: roleData.role_no,
    role_name: roleData.role_name,
    permission
  };
  return $asyncPost("v3/merchant/UserRole/generate", roleDatas);
}
/**
 * 店铺删除角色
 * v3/merchant/UserRole/delete
 * @param {string} role_id 角色id
 */
export const mUserRoledelete = function (role_id) {
  return $asyncPost(`v3/merchant/UserRole/delete?role_id=${role_id}`);
}
/**
 * 店铺枚举所有角色
 * v3/merchant/UserRole/list
 */
export const mUserRoleList = function () {
  return $asyncPost(`v3/merchant/UserRole/list?merchant_id=${localStorage.getItem("merchant_id")}`);
}
/**
 * 店铺设置角色权限
 * v3/merchant/UserRole/SetRolePermission
 * @param {string} role_id 角色id
 * @param {Array<string>} permissionArr 权限数组
 */
export const mUserRoleSetRolePermission = function (role_id, permissionArr) {
  return $asyncPost(`v3/merchant/UserRole/SetRolePermission?role_id=${role_id}&merchant_id=${localStorage.getItem("merchant_id")}`, permissionArr);
}
/**
 * 店铺停用角色
 * v3/merchant/UserRole/SetRoleStatus
 * @param {string} role_id 角色id
 * @param {boolean} status 角色状态
 */
export const mUserRoleSetRoleStatus = function (role_id, status) {
  return $asyncPost("v3/merchant/UserRole/SetRoleStatus", { role_id, status });
}

/**
 * 店铺获取所有用户
 * v3/merchant/permission/merchant/ListAccount
 * @returns 
 */
export const mListAccount = function () {
  return $asyncGet(`v3/merchant/permission/merchant/ListAccount?merchant_id=${localStorage.getItem("merchant_id")}`);
}

/**
 * 店铺查询用户授权
 * @param {string} account_id 用户id
 */
export const mQueryAccount = function (account_id) {
  return $asyncGet(`v3/merchant/permission/merchant/query?merchant_id=${localStorage.getItem("merchant_id")}&account_id=${account_id}`);
}

/**
 * 店铺设置用户角色
 * @param {string} account_id 用户id
 * @param {Array<string>} permissionArr 角色id数组
 */
export const mSetRole = function (account_id, permissionArr) {
  return $asyncPost(`v3/merchant/permission/merchant/SetRole?merchant_id=${localStorage.getItem("merchant_id")}&account_id=${account_id}`, permissionArr)
}

/**
 * 店铺激活线下权限线上权限生效
 * v3/merchant/permission/merchant/ActiveOfflinePermission
 */
export function mActiveOfflinePermission() {
  return $asyncGet(`v3/merchant/permission/merchant/ActiveOfflinePermission?merchant_id=${localStorage.getItem("merchant_id")}`);
}

/**
 * 获取到用户可用的所有店铺
 * v3/merchant/permission/account/listMerchant
 */
export function mAccountListMerchant() {
  return $asyncGet(`v3/merchant/permission/account/listMerchant`);
}

/**
 * 店铺删除用户
 * /v3/merchant/permission/merchant/delete
 * @param {string} account_id 用户id
 */
export function mDeleteAccount(account_id) {
  return $asyncPost(`v3/merchant/permission/merchant/delete?merchant_id=${localStorage.getItem("merchant_id")}&account_id=${account_id}`)
}

/**
 * 获取所有支付通道
 * @returns 
 */
export function baseListChanner() {
  return $asyncGet(`v3/merchant/Pay/base/ListChannel?merchant_id=${localStorage.getItem("merchant_id")}`)
}

/**
 * 获取店铺支付配置
 * @returns 
 */
export function basePayQuery() {
  return $asyncPost(`v3/merchant/Pay/base/Query?merchant_id=${localStorage.getItem("merchant_id")}`, {})
}

/**
 * 删除店铺支付配置
 * @param {string} setting_id 配置id
 * @returns 
 */
export function basePayDelete(setting_id) {
  return $asyncPost(`/v3/merchant/Pay/base/delete?merchant_id=${localStorage.getItem("merchant_id")}&setting_id=${setting_id}`);
}

/**
 * 配置店铺支付
 * @param {*} data 
 * @returns 
 */
export function basePayConfigure(data) {
  return $asyncPost(`v3/merchant/pay/base/Configure?merchant_id=${localStorage.getItem("merchant_id")}`, data);
}

